<div class="cio">
  <div class="buttons" [ngClass]="routeAnimationsElements">
    <button (click)="onCancel()" mat-icon-button color="primary" style="background-color: #004a8f; padding: 0px;">
      <mat-icon style="color: white;">arrow_back</mat-icon>
    </button>
  </div>
  <mat-tab-group>
    <mat-tab label="Sitios de procesamiento">
      <div class="buttons">
        <button mat-raised-button (click)="onGuardar()" color="primary">
          Agregar sitio de procesamiento
        </button>
      </div>
      <rpe-base-table [baseTable]="sitioProcesamientoTable" [showActions]="true" [actionMenu]="false"></rpe-base-table>
    </mat-tab>
    <mat-tab label="Máquinas móviles">
      <div class="buttons">
        <button mat-raised-button (click)="onAddMaquinaMovil()" color="primary">
          Agregar máquinas móviles
        </button>
      </div>
      <rpe-base-table [baseTable]="maquinaMovilTable" [showActions]="true" [actionMenu]="false"></rpe-base-table>
    </mat-tab>
  </mat-tab-group>
</div>